<template lang="pug">
  v-col(cols="12")
    v-card
      v-card-text
        h2.text-center Escrutino
        v-simple-table
          template
            thead
              tr
                th
                th
                th
            tbody
              tr(v-for="number in 15")
                td Nombre
                td  ID
                td {{number}}
</template>

<script>
  export default {
    name: "ContestScrutiny"
  }
</script>

<style lang="sass">
</style>